export default [
  {
    optinStatus: null,
    disclaimerText: [
      {
        text: "*By clicking 'subscribe', you agree to receive promotional and personalized marketing text messages from Priceline to the mobile number provided during sign-up. Messages may be sent using an automatic telephone dialing system. Consent is not required as a condition of purchase. Reply STOP at any time to cancel. Msg frequency varies. Msg and data rates may apply. Offer only valid for customers with U.S. phone numbers. Applicable terms and privacy policy available at: ",
        url: null
      },
      {
        text: 'terms',
        url: 'https://www.priceline.com/static-pages/terms_en.html'
      },
      {
        text: ' & ',
        url: null
      },
      {
        text: 'privacy',
        url: 'https://www.priceline.com/static-pages/privacy-policy.html'
      },
      {
        text: '.',
        url: null
      }
    ]
  }
]
